// extracted by mini-css-extract-plugin
export var container = "_bx-0";
export var icon = "_bx-1";
export var text = "_bx-2";